export const ApportionmentType = {
  OtherVehicle: 'OutroVeiculo',
  Digital: 'Digital'
};
